import script from "./PacketsDB.vue?vue&type=script&setup=true&lang=js"
export * from "./PacketsDB.vue?vue&type=script&setup=true&lang=js"

import "./PacketsDB.vue?vue&type=style&index=0&id=78432187&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78432187"]])

export default __exports__